<template>
    <el-dialog class="dialog" :visible="dialogs.okz" :close-on-click-modal="false" @close="closeDialog()" customClass="dialog_main" :append-to-body="true" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Группа занятий</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <div class="dialog__content">
                <form class="search-form" @submit.prevent>
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    max-height="300"
                    ref="table"
                    row-key="id"
                    :data="filteredData"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column
                            width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox @change="handleSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код ОКЗ"
                        prop="code"
                        sortable
                        :min-width="12"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    max-height="300"
                    row-key="id"
                    :show-header="false"
                    :data="selection"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код ОКЗ"
                        prop="code"
                        sortable
                        :min-width="12"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <el-pagination
                    background
                    class="mt-24"
                    layout="prev, pager, next"
                    :current-page="page"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="filtered.length"
                    @current-change="setPage"
                >
                </el-pagination>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные ОКЗ</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import dialog from '@/mixins/dialog';

import { debounce } from '@/helpers';

export default {
    mixins: [ dialog ],
    methods: {
        ...mapActions('editor', ['CREATE_OKZS']),
        closeDialog() {
            this.selection = []
            
            this.elDialogs.okz = false;
        },
        async handleOpen() {
            this.data = [...this.okzs];
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            const okzs = this.selection.map((item) => item.id);
            const params = {
                standardId:  this.standard.id,
                ids: okzs
            }

            await this.CREATE_OKZS(params)

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['okzs', 'standard']),
        filtered() {
            // Фильтруем по поиску
            const tempArr = this.data.filter(item => !this.standard.okzs.includes(item.id))
            return !this.searchValue ? tempArr : tempArr.filter((item) => String(item.code).toLowerCase().includes(this.searchValue.toLowerCase()) || item.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        },
        tableData() {
            // Пагинация
            return this.filtered.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        },
        filteredData() {
            return this.tableData.filter(el => !this.selection.find(select => select.id === el.id))
        }
    }
}
</script>
